import { DropdownFieldLink } from '@cian/components';
import * as React from 'react';

import { ECurrencyType } from '../../../json_query';

const style = require('./index.css');

export const currencyTypeMap = {
  [ECurrencyType.Dollar]: '\u0024',
  [ECurrencyType.Rouble]: '\u20BD',
  [ECurrencyType.Euro]: '\u20AC',
};

export interface ICurrencyTypeSelectProps {
  currencyType: ECurrencyType;
  onCurrencyTypeChanged(currencyType: ECurrencyType): void;
}

export class CurrencyTypeSelect extends React.Component<ICurrencyTypeSelectProps> {
  public render() {
    const props = this.props;

    return (
      <DropdownFieldLink
        buttonStyle={style.currencyType}
        value={props.currencyType}
        onValueChange={(value: ECurrencyType) => props.onCurrencyTypeChanged(value)}
        values={[
          { value: ECurrencyType.Dollar, label: currencyTypeMap[ECurrencyType.Dollar] },
          { value: ECurrencyType.Rouble, label: currencyTypeMap[ECurrencyType.Rouble] },
          { value: ECurrencyType.Euro, label: currencyTypeMap[ECurrencyType.Euro] },
        ]}
      />
    );
  }
}
